module.exports = __webpack_public_path__ + "img/SUPER-OK-whiskey-V1-smallest.9ad84049.png";